import { render, staticRenderFns } from "./BaseLoadingLogo.vue?vue&type=template&id=1df12093"
import script from "./BaseLoadingLogo.vue?vue&type=script&lang=js"
export * from "./BaseLoadingLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports